import type { UserDataDto } from "@strtmn/sds/types"
import { I18n } from "aws-amplify/utils"
import { useNavigate, useSearchParams } from "react-router-dom"
import { filterUsers, sortUsers } from "../../api/userData"

interface UserTableProps {
  users: UserDataDto[]
  newUsers: boolean
}

export default function UserTable({ users, newUsers }: UserTableProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  function redirectToEditUser(user: UserDataDto) {
    const url = `../users/${user.id}`
    if (newUsers) {
      navigate(url, {
        state: {
          isNewUser: true,
          user,
        },
      })
    } else {
      navigate(url)
    }
  }

  if (users.length === 0) {
    return <div className="search-result-info">{I18n.get("Keine Daten.")}</div>
  }

  const filter = searchParams.get("filter")?.toLocaleLowerCase()
  let usersSorted: UserDataDto[]
  if (newUsers) {
    // Cognito users have been mapped to UserDataDto in the ACU page itself
    const cognitoUsersFiltered = filterUsers(users, filter)
    // Sorting happens in the ACU page itself
    usersSorted = cognitoUsersFiltered
  } else {
    const usersFiltered = filterUsers(users, filter)
    usersSorted = sortUsers(usersFiltered)
  }

  return (
    <table className="admin-table w-full">
      <thead>
        <tr>
          <th>{I18n.get("Nachname")}</th>
          <th>{I18n.get("Vorname")}</th>
          <th>{"E-Mail"}</th>
        </tr>
      </thead>
      <tbody>
        {usersSorted.map((user) => (
          <tr
            key={user.id}
            onClick={() => redirectToEditUser(user)}
            style={{ cursor: "pointer" }}
          >
            <td>{!newUsers && user.last_name}</td>
            <td>{!newUsers && user.first_name}</td>
            <td>{user.email}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
